<script lang="ts">
  import { onMount } from 'svelte';
  import type { SwiperOptions } from 'swiper/types';
  import { isMobileWidth } from '../../../common/util';
  // import PictureTag from '../lazy-components/PictureTag.svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getBottomTags } from '../../brand/services/brand-data-services';
  import { getBannerDestination, trackRMNBannerClick } from '../services/banner-utils';
  import { getInStockProductsById } from '../services/unbxd';
  import ExtraNewProuctCardSlideTemplate from './ExtraNewProuctCardSlideTemplate.svelte';
  import ExtraSwiper from './ExtraSwiper.svelte';

  export let bannerData;
  export let isGridView = false;
  let products = [];
  let loading = true;
  const isResponsive = isMobileWidth();
  const { pageId } = getAppConfig();
  function getSwiperOptions(slides, space): SwiperOptions {
    return {
      slidesPerView: slides,
      spaceBetween: space,
      navigation: !isResponsive,
      centeredSlides: false,
    };
  }
  const productTileSwiperOptions = getSwiperOptions('auto', isResponsive ? 5 : 8);

  function pushAddIdIntoProductArray(products, bannerData) {
    const adIdMap = new Map(bannerData?.products?.map(item => [item.productId, item.adId]));

    products.forEach(item => {
      const adId = adIdMap.get(item?.productCode);
      if (adId) {
        item.adId = adId;
      }
    });
    return products;
  }

  async function loadProducts() {
    if (!bannerData?.productIds?.length) return;
    try {
      const res = await getInStockProductsById(bannerData.productIds);

      products = res?.response?.products || [];
      if (products?.length) {
        products = pushAddIdIntoProductArray(products, bannerData);
      }
      console.log('products', products);
    } catch (e) {
      console.error('bannerData product fetch failed', e);
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    loadProducts();
  });

  function handleBannerClick() {
    window.ACC.miraklads.registerClickAsync(bannerData?.adId);
    trackRMNBannerClick({
      bannerId: bannerData?.adId,
      isSponsored: true,
      bannerType: pageId !== 'homepage' ? 'Shoppable ad ' : 'Editorial Module',
      bannerDestination: getBannerDestination(bannerData?.redirectUrl),
    });

    if (bannerData?.redirectUrl) {
      window.location.href = bannerData.redirectUrl;
    }
  }

  $: hasAnyBottomTags = products.some(product => getBottomTags(product).some(tag => tag.theme !== 'dummy'));
  $: tileWidth =
    pageId === 'productList' || pageId === 'search'
      ? isResponsive
        ? '126px'
        : '241px'
      : bannerData.width
        ? `${bannerData.width / 2}px`
        : '100%';
</script>

<section class="sponsored-row">
  <!-- svelte-ignore a11y-click-events-have-key-events -->

  <div
    data-mirakl-view-id={bannerData.adId}
    class="banner-data-container"
    style:--tile-width={tileWidth}
    on:click={handleBannerClick}
  >
    {#if bannerData.videoUrl}
      <video src={bannerData.videoUrl} autoplay muted loop playsinline class="bannerData-video" />
    {:else}
      <!-- svelte-ignore a11y-img-redundant-alt -->
      <img
        src={isResponsive
          ? `${bannerData.imageUrl}?fmt=auto&h=338`
          : `${bannerData.imageUrl}?fmt=auto&h=${pageId === 'homepage' ? 348 : 220}`}
        alt="Product image"
      />
    {/if}
    {#if pageId === 'homepage' && hasAnyBottomTags}
      <div class="banner-bottom-section"></div>
    {/if}
  </div>

  {#if !loading && products.length > 0}
    <div class="products-scroll">
      <ExtraSwiper
        slidesData={products}
        slideTemplate={ExtraNewProuctCardSlideTemplate}
        swiperOptions={productTileSwiperOptions}
      />
    </div>
  {/if}
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';
  .sponsored-row {
    display: flex;
    gap: 16px;
    width: 100%;
    align-items: stretch;
    @include responsive {
      gap: 5px;
    }
  }

  .bannerData-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .banner-data-container {
    flex-shrink: 0;
    display: flex;
    max-width: var(--tile-width);
    flex-direction: column;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      border-radius: 12px;
      display: block;
    }
  }

  .products-scroll {
    flex: 1;
    display: flex;
    width: 70%;
  }

  .products-scroll :global(.swiper-wrapper) {
    height: 100%;
  }

  .products-scroll :global(.swiper) {
    height: 100%;
    margin: 0;
  }

  .products-scroll :global(.swiper-slide) {
    width: auto !important;
    display: flex;
    height: auto !important;
  }

  .products-scroll :global(.card-container) {
    border: 1px solid #dce3e9;
  }
  .banner-bottom-section {
    min-height: 24px;
    @include responsive {
      min-height: 20px;
    }
  }
  .banner-data-container,
  .bannerData-video {
    cursor: pointer;
  }
</style>
